<script>
export default {
  translate25Context: "plan.vwallet",
  components: {},
  methods: {
    humanize: function (time) {
      var humanize_time = "";

      var minutes = time % 60;

      var hours = parseInt(time / 60);

      if (hours != 0) {
        // humanize_time = hours + " " + this.$vt("Hour");
        humanize_time = this.$vtc("{count} Hour | {count} Hours", hours, {
          count: hours,
        });
      }

      if (minutes != 0) {
        humanize_time += " " +this.$vtc("{count} Minute | {count} Minutes", minutes, {
          count: minutes,
        });
      }

      return humanize_time;
    },
  },
  props: ["component", "handler"],
  data: function () {
    return {
      count: 1,
    };
  },
};
</script>

<template>
  <f-form sticky-action scroll>
    <template #title>
      <f-icon icon="fa6-right-left"></f-icon> {{ $vt("History") }}
    </template>
    <template #content>
      <div class="vwallet17">
        <div class="vwallet17-header">
          <div class="date">{{ $vt("Date") }}</div>
          <div class="description">{{ $vt("Description") }}</div>
          <div class="amount">{{ $vt("Amount") }}</div>
        </div>
        <div class="vwallet17-content">
          <f-sexy-scroll>
            <div
              class="vwallet17-items-by-day"
              v-for="(items_by_day, day) in component.items"
              :key="day"
            >
              <div
                class="vwallet17-item"
                v-for="(item, nid) in items_by_day"
                :key="nid"
              >
                <div class="new-plan" v-if="item.type == 'new_plan'">
                  <div class="date">
                    {{ (day * 1000) | angularFilter("dd/MM/yyyy", "date") }}
                  </div>
                  <div class="description">{{ item.title }}</div>
                  <div class="amount">+ {{ humanize(item.amount) }}</div>
                </div>

                <div class="expired-plan" v-if="item.type == 'expired_plan'">
                  <div class="date">
                    {{ (day * 1000) | angularFilter("dd/MM/yyyy", "date") }}
                  </div>
                  <div class="description">{{ item.title }}</div>
                  <div class="amount">{{ humanize(item.amount) }}</div>
                </div>

                <div class="extra-hour" v-if="item.type == 'extra_hour'">
                  <div class="date">
                    {{ (day * 1000) | angularFilter("dd/MM/yyyy", "date") }}
                  </div>
                  <div class="description">{{ item.title }}</div>
                  <div class="amount">+ {{ humanize(item.amount) }}</div>
                </div>

                <div class="cost" v-if="item.type == 'cost'">
                  <div class="date">
                    {{ (day * 1000) | angularFilter("dd/MM/yyyy", "date") }}
                  </div>
                  <div class="description" v-if="item.url">
                    <f-link :href="'#' + item.url">{{ item.title }}</f-link>
                  </div>
                  <div class="description" v-if="!item.url">
                    <span>{{ item.title }}</span
                    ><span class="deleted">{{ $vt("Deleted") }}</span>
                  </div>
                  <div class="amount">{{ humanize(item.amount) }}</div>
                </div>
              </div>
            </div>
          </f-sexy-scroll>
        </div>
      </div>
    </template>
  </f-form>
</template>

<style lang="scss">
plan-v-wallet-ng-component {
  width: 100%;
  .vwallet17 {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 16px;

    .vwallet17-header {
      display: flex;
      border-bottom: 2px solid var(--white-a10);

      > div {
        flex: 0 0 100px;
        color: var(--white-a75);
        font-family: Lato;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        padding: 16px 0;

        &.description {
          flex: 1 1 auto;
        }

        &.amount {
          text-align: right;
        }
      }
    }

    .vwallet17-content {
      display: flex;
      flex-direction: column;
      height: 100%;

      > .f-sexy-scroll {
        height: 0;

        .f-sexy-scroll-inner {
          display: flex;
          flex-direction: column-reverse;
        }
      }

      .vwallet17-items-by-day {
        display: flex;
        flex-direction: column;
        flex-direction: column-reverse;

        .vwallet17-item {
          display: flex;
          width: 100%;

          .new-plan,
          .expired-plan,
          .extra-hour,
          .cost {
            display: flex;
            width: 100%;

            > div {
              flex: 0 0 100px;
              padding: 16px 0;
              align-self: start;

              &.description {
                flex: 1 1 auto;
                display: flex;
                gap: 8px;
                align-items: center;
                .deleted {
                  align-self: center;
                  padding: 2px 6px;
                  background-color: var(--negative);
                  color: var(--white-a75);
                  text-transform: lowercase;
                  border-radius: 24px;
                  align-items: center;
                  font-family: Lato;
                  font-size: 10px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;
                  display: flex;
                }
              }

              &.amount {
                text-align: right;
              }
            }
          }

          .new-plan,
          .extra-hour {
            .amount {
              color: var(--statusPositive);
              font-family: Lato;
              font-size: 14px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
            }
          }

          .cost,
          .expired-plan {
            .amount {
              color: var(--statusNegative);
              font-family: Lato;
              font-size: 14px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
            }
          }
        }
      }
    }
  }
}
</style>